import * as React from "react";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { FormHelperText, TextField, Theme, WithStyles } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { ChangeEvent } from "react";
import { withStyles } from "@material-ui/core/styles";
import { IMembershipsFilter } from "../types/IMembershipsFilter";

const styles = (theme: Theme) => ({
  filterContainer: {
    marginTop: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    justify: "flex-start",
    alignItems: "center"
  }
});

interface IState {

}

interface IProps extends WithStyles<typeof styles> {
  filter: IMembershipsFilter,
  disabled: boolean,
  onChangeStatusFilter(status: string, checked: boolean): void,
  onChangeTextFilter(e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void,
  entityNameFilterIsValid(): void
}

class CommunityMembershipsFilter extends React.Component<IProps, IState> {
  public render() {
    const { classes, filter } = this.props;
    return <Grid container className={classes.filterContainer} spacing={16}>
      <Grid item>
        <FormControlLabel
          control={
            <Checkbox
              checked={filter.statuses.active}
              disabled={this.props.disabled}
              color="secondary"
              onChange={(e: any) => this.props.onChangeStatusFilter('active', e.target.checked)}
            />
          }
          label="Active"
        />
        <FormHelperText/>
      </Grid>
      <Grid item>
        <FormControlLabel
          control={
            <Checkbox
              disabled={this.props.disabled}
              checked={filter.statuses.pending}
              color="secondary"
              onChange={(e: any) => this.props.onChangeStatusFilter('pending', e.target.checked)}
            />
          }
          label="Pending"
        />
        <FormHelperText/>
      </Grid>
      <Grid item>
        <FormControlLabel
          control={
            <Checkbox
              disabled={this.props.disabled}
              checked={filter.statuses.disabled}
              color="secondary"
              onChange={(e: any) => this.props.onChangeStatusFilter('disabled', e.target.checked)}
            />
          }
          label="Disabled"
        />
        <FormHelperText/>
      </Grid>
      <Grid item>
        <FormControlLabel
          control={
            <Checkbox
              disabled={this.props.disabled}
              checked={filter.statuses.denied}
              color="secondary"
              onChange={(e: any) => this.props.onChangeStatusFilter('denied', e.target.checked)}
            />
          }
          label="Denied"
        />
        <FormHelperText/>
      </Grid>
      <Grid item>
        <TextField
          disabled={this.props.disabled}
          value={filter.entity || ""}
          name="entity"
          onChange={this.props.onChangeTextFilter}
          InputProps={{
            endAdornment: (
              <SearchIcon/>
            )
          }}
          placeholder="Entity name"
          error={!this.props.entityNameFilterIsValid()}
          helperText={this.props.entityNameFilterIsValid() ? " " : "Enter more than 3 characters"}
        />
      </Grid>
    </Grid>;
  }
}

export default withStyles(styles)(CommunityMembershipsFilter)


// WEBPACK FOOTER //
// ./src/modules/communities/components/CommunityMembershipsOverviewFilter.tsx